/* eslint-disable */
export default {
  onSearching: '読み込み中...',
  noContacts: '記録が見つかりません。',
} as const;

// @key: @#@"onSearching"@#@ @source: @#@"Loading..."@#@
// @key: @#@"noContacts"@#@ @source: @#@"No records found."@#@
